
import React from 'react';
import { CORE_VALUES } from '../constants';

const Values: React.FC = () => {
  return (
    <section id="why-us" className="py-40 relative scroll-mt-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center text-center mb-24 space-y-6">
          <h2 className="text-[11px] font-black text-brand-400 font-mono tracking-[0.6em] uppercase">OPERATIONAL CORE</h2>
          <h3 className="text-5xl md:text-6xl font-black text-white tracking-tighter">The Sentrix Standard</h3>
          <p className="text-slate-400 max-w-2xl font-light text-lg">
            Our engineering DNA is built on five immutable principles that ensure your intelligence assets remain uncompromised.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {CORE_VALUES.map((value, idx) => (
            <div 
              key={value.title} 
              className="glass-card border-beam p-10 rounded-[2.5rem] flex flex-col items-center text-center group transition-all duration-700"
            >
              <div className="relative mb-8">
                <div className="absolute inset-0 bg-brand-500/20 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center relative z-10 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
                  {value.icon}
                </div>
              </div>
              <h4 className="font-black text-white text-lg mb-4 tracking-tight group-hover:text-brand-300 transition-colors uppercase">{value.title}</h4>
              <p className="text-slate-500 text-sm leading-relaxed font-medium group-hover:text-slate-300 transition-colors">
                {value.description}
              </p>
              
              <div className="mt-8 flex gap-1 opacity-20 group-hover:opacity-100 transition-opacity">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="w-1 h-1 bg-brand-400 rounded-full" />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
